import fetch from "auth/FetchInterceptor";

const actionPlansService = {};

actionPlansService.get = function (params = {}) {
	return fetch({
		url: "/v1/rest/action-plans",
		method: "get",
		params,
	});

	// return (
	// 	[
	// 		...Array(30).keys()
	// 	].map((i) => ({
	// 		id: i,
	// 		nome: `Setor ${i}`,
	// 	}))
	// );
};

actionPlansService.getByYear = function (year) {
	return fetch({
		url: "/v1/rest/action-plans",
		method: "get",
		params: { year },
	});
};

actionPlansService.post = function (data) {
	return fetch({
		url: "/v1/rest/action-plans",
		method: "post",
		data: data,
	});
};

actionPlansService.postCopyActionPlan = function (data, company_id) {
	return fetch({
		url: `/v1/rest/action-plans-in-company-schema/${company_id}`,
		method: "post",
		data: data,
	});
};

actionPlansService.put = function (id, data) {
	return fetch({
		url: `/v1/rest/action-plans/${id}`,
		method: "put",
		data: data,
	});
};

actionPlansService.delete = function (id) {
	return fetch({
		url: `/v1/rest/action-plans/${id}`,
		method: "delete",
	});
};

actionPlansService.getById = function (id) {
	return fetch({
		url: `/v1/rest/action-plans/${id}`,
		method: "get",
	});
};

// Novos métodos para planos inativos
actionPlansService.getInactives = function (params = {}) {
	return fetch({
		url: "/v1/rest/action-plans-inactives",
		method: "get",
		params,
	});
};

actionPlansService.getInactivesByYear = function (year) {
	return fetch({
		url: "/v1/rest/action-plans-inactives",
		method: "get",
		params: { year },
	});
};

actionPlansService.getInactiveById = function (id) {
	return fetch({
		url: `/v1/rest/action-plans-inactives/${id}`,
		method: "get",
	});
};

export default actionPlansService;
